import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DateField } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { formatToISODate } from "@/utils/formatDate";
import { customersSelector, saveCustomer, updateCustomer } from "../../../store/slices/applicationFormSlice";

const QuoteDateOfBirth = ({ applicationId, disabled }) => {
  const dispatch = useDispatch();
  const customers = useSelector(customersSelector);
  const [dateOfBirth, setDateOfBirth] = useState(null);

  function updateDateOfBirth(value) {
    dispatch(
      saveCustomer({
        customerId: customers[0]?._id,
        dateOfBirth: formatToISODate(value),
      }),
    );

    dispatch(
      updateCustomer({
        data: {
          applicationId,
          customerId: customers[0]?._id,
          data: {
            dateOfBirth: formatToISODate(value),
          },
        },
      }),
    );
  }

  useEffect(() => {
    if (customers?.[0]?.dateOfBirth) {
      setDateOfBirth(dayjs(customers?.[0]?.dateOfBirth, "YYYY-MM-DD"));
    }
  }, [customers?.[0]?.dateOfBirth]);

  return (
    <DateField
      fullWidth
      label="Date of birth"
      size="small"
      format="DD-MM-YYYY"
      variant="filled"
      value={dateOfBirth || null}
      style={{ background: "#ffffff" }}
      onChange={(event) => {
        setDateOfBirth(event?.$d || null);
      }}
      onBlur={() => updateDateOfBirth(dateOfBirth)}
      disabled={disabled}
    />
  );
};

export default QuoteDateOfBirth;
